import $ from 'jquery'
import autosize from 'autosize'

export default function(context = document.body)
{
	const $context = $(context)
	autosize($context.find('textarea[data-autosize]'))
}



/** WEBPACK FOOTER **
 ** ./source/scripts/components/autosize.js
 **/